import get from 'lodash/get';

import { AppConfig, useAppConfig } from '../fetching/api/appConfig';
import { Objects } from '../types/objects';

/**
 * @param path - The dot-annotated json path to the specific leaf value in the app config.
 * @returns the value of the corresponding path.
 *
 * @example
 * const canCreateQualification = useConfigValue('qualification.create');
 * console.log(canCreateQualification); // true
 */
export const useConfigValue = (path: AppConfigLeafPaths): boolean => {
    const appConfig = useAppConfig();
    return get(appConfig, path);
};

type AppConfigLeafPaths = Objects.LeafPaths<AppConfig>;
